import { render, staticRenderFns } from "./order-header.vue?vue&type=template&id=152f7ce3&scoped=true"
import script from "./order-header.vue?vue&type=script&lang=js"
export * from "./order-header.vue?vue&type=script&lang=js"
import style0 from "./order-header.vue?vue&type=style&index=0&id=152f7ce3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152f7ce3",
  null
  
)

export default component.exports